import RouterConfig from './RouterConfig';

function Router() {
  return <RouterConfig />;
}

export default Router;
